import cn from 'classnames';

import { buildTagCopyPlan } from '../utils';

import { Tag } from '../../types/tagTypes';

import styles from './CopyTag.module.scss';

type TagRelationPreviewProps = {
    relationTagIds: number[];
    sourceTags: Tag[];
    targetTags: Tag[];
    showTargetPlan: boolean;
};

export function TagRelationPreview(props: TagRelationPreviewProps) {
    const { relationTagIds, sourceTags, targetTags, showTargetPlan } = props;

    if (relationTagIds.length === 0) {
        return <>—</>;
    }

    if (!showTargetPlan) {
        const stringIds = relationTagIds
            .map((id) => sourceTags.find((t) => t.id === id)?.stringId)
            .filter(Boolean);
        return <>{stringIds.join(', ')}</>;
    }

    const plan = buildTagCopyPlan(relationTagIds, sourceTags, targetTags);

    return (
        <ul className={styles.relationList}>
            {plan.map((entry) => (
                <li key={entry.sourceTag.stringId}>
                    {entry.sourceTag.stringId}
                    <span
                        className={cn(
                            styles.relationBadge,
                            entry.isNew && styles.relationBadgeNew,
                        )}
                    >
                        {entry.isNew ? 'new — will be created' : 'exists'}
                    </span>
                </li>
            ))}
        </ul>
    );
}
